import { Injectable } from '@angular/core';
import { Observable, ReplaySubject, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import {environment} from '../../environments/environment';
import {User} from '../models/user.model';
import { Role } from 'app/models/role.model';
import { RoleModule } from 'app/models/roleModule.model';

@Injectable({
    providedIn: 'root'
})
export class RoleService {

    private API_URL= environment.API_URL;
    private MODEL_URL = 'roles';
    private _modules: ReplaySubject<Array<any>> = new ReplaySubject<Array<any>>(1);

    constructor(private http: HttpClient) { }

    getRoles(): Observable<Role[]> {
        return this.http.get<Role[]>(this.API_URL + this.MODEL_URL);
    }

    getRole(id: number): Observable<Role> {
        return this.http.get<Role>(this.API_URL + this.MODEL_URL + '/' + id);
    }

    getRoleModules(id: number): Observable<RoleModule[]> {
        return this.http.get<RoleModule[]>(this.API_URL + this.MODEL_URL + '/' + id + '/modules');
    }

    getAllRoleModules(): Observable<Array<any>> {
        return this.http.get<Array<any>>(this.API_URL + this.MODEL_URL + '/modules');
    }

    savePermissions(id: number, modules): Observable<Role> {
        return this.http.post<Role>(this.API_URL + this.MODEL_URL + '/' + id, {modules: modules});
    }

    getSelectedModules(){
        let modules;
        this.modules$.subscribe((modulesReponse) => {
          modules = modulesReponse;
        }).unsubscribe();

        return modules;
    }

    set modules(value: Array<any>)
    {
        this._modules.next(value);
    }

    get modules$(): Observable<Array<any>>
    {
        return this._modules.asObservable();
    }
}
